import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { message } from 'antd'

import TodoHeader from "../components/TodoHeader"
import TodoTable from "../components/TodoTable"
import TimeUtils from "../utils"
import deviceApi from "../services/api"
import { formatText } from "../utils/richText"
import './detail.css'

function Detail() {
    const params = useParams()
    const navigate = useNavigate()
    const date = params.date || TimeUtils.today()

    const ref = React.useRef(null)
    const [loading, setLoading] = React.useState(true)
    const [data, setData] = React.useState({
        time: date,
        blur: false,
        extraInfo: "tips",
        note: "",
        noteIsPublic: true,
        items: [],
    })

    const loadData = React.useCallback(async () => {
        setLoading(true)
        try {
            const resp = await deviceApi.getDetail(date)
            const blurState = resp.blur || false
            setData({
                time: resp.time || date,
                blur: blurState,
                extraInfo: resp.extraInfo || "tips",
                note: resp.note || "",
                noteIsPublic: resp.note_is_public !== false,
                items: resp.items || [],
            })
        } catch (error) {
            message.error(`加载数据失败: ${error.message}`)
        } finally {
            setLoading(false)
        }
    }, [date])

    React.useEffect(() => {
        loadData()
    }, [loadData])

    // 渲染数据到DOM
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(() => {
        if (!loading && ref.current) {
            renderDataToDOM()
            if (data.blur) {
                setTimeout(() => {
                    const blurElements = ref.current?.querySelectorAll('.container-todo, .container-limit, tbody.ne-table-inner')
                    blurElements?.forEach(el => {
                        el.classList.add('blur')
                    })
                }, 0)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, loading])

    const renderDataToDOM = () => {
        const container = ref.current
        if (!container) return

        const todoElement = container.querySelector('.container-todo')
        if (todoElement) {
            const todoContent = data.note || ''
            todoElement.innerHTML = `<div class="container-todo-content">${todoContent.replace(/\n/g, '<br>')}</div>`
        }

        const tableInner = container.querySelector('.ne-table')
        if (tableInner && data.items && data.items.length > 0) {
            const colgroup = tableInner.querySelector('colgroup')
            const header = tableInner.querySelector('thead.ne-tr')
            tableInner.innerHTML = ''
            if (colgroup) {
                tableInner.appendChild(colgroup)
            }
            if (header) {
                tableInner.appendChild(header)
            }
            data.items.forEach((item) => {
                const tbody = document.createElement('tbody')
                tbody.className = 'ne-table-inner'
                tbody.innerHTML = `
                    <tr class="ne-tr">
                        <td class="ne-td ne-td-middle" rowspan="3" data-col="0">
                            ${formatText(item.project || '')}
                        </td>
                        <td class="ne-td ne-td-middle ne-td-select" rowspan="3" data-col="1">
                            ${item.is_public === false ? '仅自见' : '可见'}
                        </td>
                        <td class="ne-td ne-td-middle ne-td-select" rowspan="3" data-col="2">
                            ${formatText(item.time || '')}
                        </td>
                        <td class="ne-td ne-td-middle ne-td-select" rowspan="3" data-col="3">
                            ${item.score || 0}
                        </td>
                        <td class="ne-td" data-col="4">
                            ${formatText(item.extra?.plan || '')}
                        </td>
                    </tr>
                    <tr class="ne-tr">
                        <td class="ne-td" data-col="4">
                            ${formatText(item.extra?.done || '')}
                        </td>
                    </tr>
                    <tr class="ne-tr">
                        <td class="ne-td" data-col="4">
                            ${formatText(item.extra?.summary || '')}
                        </td>
                    </tr>
                `
                tableInner.appendChild(tbody)
            })
        }
    }

    // 快捷键支持
    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable || e.altKey) {
                return
            }

            if (e.key === 'a' || e.key === 'ArrowLeft') {
                e.preventDefault()
                const yesterday = TimeUtils.getPreviousDay(date)
                navigate(`/detail/${yesterday}`)
            }
            if (e.key === 'd' || e.key === 'ArrowRight') {
                e.preventDefault()
                const tomorrow = TimeUtils.getNextDay(date)
                navigate(`/detail/${tomorrow}`)
            }
            if (e.key === 'e') {
                e.preventDefault()
                navigate(`/edit/${date}`)
            }
        }

        document.addEventListener('keydown', handleKeyDown)
        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [date, navigate])

    if (loading) {
        return <div className="container">加载中...</div>
    }

    return (
        <div className="container" ref={ref}>
            <TodoHeader time={data.time} note={data.note} noteIsPublic={data.noteIsPublic} />
            <TodoTable items={data.items} />
        </div>
    )
}

export default Detail
